

let inject = [
  '$scope',
  'CatalogService',
  'CategoryService',
  '$state',
  '$rootScope',
  'SharedService',
  '$stateParams',
  '$uibModal',
  'Pagination',
  'ngAuthSettings',
  '$timeout',
  'CartService',
  'ByFavoritesService',
  'SessionService'
];

class ProductsListFiltersController {
  constructor($scope, CatalogService, CategoryService, $state, $rootScope, SharedService, $stateParams, $uibModal, Pagination, ngAuthSettings, $timeout, CartService, ByFavoritesService, SessionService) {
    this.$state = $state;
    this.$scope = $scope;
    this.ngAuthSettings = ngAuthSettings;
    this.Pagination = Pagination;
    this.CatalogService = CatalogService;
    this.$stateParams = $stateParams;
    this.CartService = CartService;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.SessionService = SessionService;
    this.CategoryService = CategoryService;
    this.SharedService = SharedService;
    this.$timeout = $timeout;
  }

  $onInit() {

  }


}

ProductsListFiltersController.$inject = inject;

export default ProductsListFiltersController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/products-list-filters/products-list-filters.controller.js
 **/